import React, { useState, useEffect } from "react";
import { Modal, Input, InputNumber, Button, Form, message, Rate } from "antd";
import {
  getFeedbackSettings,
  updateFeedbackSettings,
} from "../services/feedbackService";

function FeedbackSetting() {
  const [open, setOpen] = useState(true);
  const [id, setId] = useState(null);

  const [formData, setFormData] = useState({
    review: "",
    subReview: "",
    customerRatings: 0,
  });

  const [rating, setRating] = useState(0);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await getFeedbackSettings();

      const data = res.data.data[0];

      setFormData({
        review: data.review,
        subReview: data.subReview,
        customerRatings: data.customerRatings,
      });

      setRating(data.customerRatings);
      setId(data.id);
    } catch {
      message.error("Failed to load data");
    }
  };

  // Change Add

const handleChange = (name, value) => {
  setFormData({
    ...formData,
    [name]: value,
  });

  if (name === "customerRatings") {
    setRating(value || 0); // no rounding
  }
};

  // Update

  const handleUpdate = async () => {
    try {
      if (!id) return message.error("ID not found");

      const payload = {
        review: formData.review,
        subReview: formData.subReview,
        customerRatings: formData.customerRatings
      };

      await updateFeedbackSettings(id, payload);

      message.success("Updated Successfully ");
    } catch {
      message.error("Update Failed ");
    }
  };
  return (
    <Modal
      title="Feedback Setting"
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
      className="custom-modal"
      closable={false}
    >
      <Form layout="vertical">
        <Form.Item label="Review">
          <Input
            value={formData.review}
            onChange={(e) => handleChange("review", e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Sub Review" >
          <Input
            value={formData.subReview}
            onChange={(e) => handleChange("subReview", e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Customer Ratings (1-5)" >
          <InputNumber
            min={1}
            max={5}
            step={0.5}
            style={{ width: "100%" }}
            value={formData.customerRatings}
            onChange={(value) => handleChange("customerRatings", value)}
          />
        </Form.Item>

        {/* Live Star */}
        <div style={{ marginBottom: 15 }}>
          <Rate disabled value={rating} />
        </div>

        <Button type="primary" block onClick={handleUpdate}>
          Update
        </Button>
      </Form>
    </Modal>
  );
}

export default FeedbackSetting;
